// Tracks the in-flight request for each kind of stream so a newer one can cancel it
const controllers = new Map();

export function startStream(key) {
  stopStream(key);
  const controller = new AbortController();
  controllers.set(key, controller);
  return controller;
}

export function stopStream(key) {
  const controller = controllers.get(key);
  if (controller) {
    controller.abort();
    controllers.delete(key);
  }
}

export function finishStream(key, controller) {
  if (controllers.get(key) === controller) {
    controllers.delete(key);
  }
}

export function isCurrentStream(key, controller) {
  return controllers.get(key) === controller && !controller.signal.aborted;
}
